import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { IpWhitelistRecordsState } from '@reducers/fhq-ip-whitelist-records';

export const getFhqIpWhitelistRecords = (state: RootState): IpWhitelistRecordsState => state.fhqIpWhitelistRecords;
export const getFhqIpWhitelistRecordsData = createSelector(getFhqIpWhitelistRecords, (records) => records?.data);
export const isFhqIpWhitelistRecordsLoading = createSelector(getFhqIpWhitelistRecords, (records) => records?.loading);
